import _ from 'lodash'
import calculatorView from '@/components/apps/pos/sale/main/common/Calculator.vue'
import { mapGetters, mapActions } from 'vuex'
import { getDefaultBinLocationId } from '@/helpers'
import { filterTaxesForSale } from '../../helpers'

export default {
  components: {
    calculatorView,
  },
  data () {
    return {
      cloneProduct: null,
    }
  },
  computed: {
    ...mapGetters({
      section: 'getPosSection',
      products: 'getPosProducts',
      product: 'getPosSelectedProduct',
      sku_id: 'getPosSelectedSkuId',
      selectedLots: 'getPosSelectedLots',
      selectedSerials: 'getPosSelectedSerials',
      orders: 'getPosOrders',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
      getMainStock: 'getMainStock', // get stock_id from primary warehouse
      isAssignedSkuToStock: 'isAssignedSkuToStock',
    }),
    hasAttribute () {
      let product = this.product
      let hasAttribute = product.prices.length > 1 ||
                        product.modifiers.length > 0 ||
                        product.discounts.length > 0 ||
                        product.taxes.length > 0
      return hasAttribute
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'setPosSectionWith',
      'addPosOrder',
      'setPosSelectedProduct',
    ]),
    setUI () {
      var sectionHeight = $('.section').outerHeight()
      var wrapperCalculatorHeight = $('.wrapper-calculator').outerHeight()
      var label = $('span.label').outerHeight()

      $('.wrapper-calculator').css({
        'top': (sectionHeight - wrapperCalculatorHeight - label) / 2 + 'px',
      })
    },
    setPrice (sku_id, product, newPrice) {
      for (let i in product.prices) {
        let sku = product.prices[i]
        if (sku.sku_id == sku_id) {
          sku.price = newPrice
        }
      }
      return product
    },
    onClickBack () {
      let product = this.product

      if (this.section.prev == 'choose-product') {
        // set section
        this.setPosSection('choose-product')
      } else if (this.section.prev == 'choose-attribute') { // back to choose attributes
        // clear sku_id
        this.$store.dispatch('clearPosSelectedSkuId')
        // set section
        this.setPosSectionWith({
          section: 'choose-attribute',
          data: {
            product: product,
          },
        })
      }
    },
    onSubmitCalc (isValid, number) {
      if (!isValid) {
        return
      }

      let product = this.product
      let newPrice = number

      if (!this.hasAttribute) {
        const branchAssignWhId = this.$store.state.posBranch.branch.whId
        let queue_number = this.queue_number
        let table_number = this.table_number
        let stocks = product.prices[0].stocks
        let sku_id = product.prices[0].sku_id
        let item = this.getProductFullName(product.product_name, product.prices[0].attributes)
        let price = newPrice
        let cost = product.prices[0].cost
        let quantity = 1
        let attributes = product.prices[0].attributes
        let discounts = product.discounts
        let taxes = filterTaxesForSale(product.taxes)
        let stock_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) ? stocks[0].stock_id : null
        let warehouse_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) ? stocks[0].warehouse_id : null
        const bin_location_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? getDefaultBinLocationId(stocks[0].stock_locations) : null
        let unit = product.unit

        const newOrder = {
          queue_number: queue_number,
          table_number: table_number,
          sku_id: sku_id,
          item: item,
          price: price,
          cost: cost,
          quantity: quantity,
          attributes: attributes,
          modifiers: [],
          discounts: discounts,
          taxes: taxes,
          stock_id: stock_id,
          warehouse_id: warehouse_id,
          bin_location_id: bin_location_id,
          unit: unit,
        }

        if (this.selectedLots.length) {
          newOrder.lots = this.selectedLots
        }

        if (this.selectedSerials.length) {
          newOrder.serials = this.selectedSerials
        }

        // add order
        this.addPosOrder(newOrder)
        // set section
        this.setPosSection('choose-product')
      } else { // back to choose attributes
        // set new price
        this.setPrice(this.sku_id, this.cloneProduct, newPrice)
        // set section
        this.setPosSectionWith({
          section: 'choose-attribute',
          data: {
            product: this.cloneProduct,
          },
        })
      }
    },
    handleWindowResize (event) {
      var that = this
      setTimeout(() => {
        // set ui
        that.setUI()
      }, 10)
    },
    getSku (skus, sku_id) {
      return skus.find(sku => sku.sku_id == sku_id)
    },
    handleKeyup (e) {
      if (e.key == 'Escape') {
        this.setPosSection('choose-product')
      }
    },
  },
  watch: {

  },
  mounted: function () {
    // clone
    this.cloneProduct = _.cloneDeep(this.product)
    // set ui
    this.setUI()
    // resize
    window.addEventListener('resize', this.handleWindowResize)
    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)
  },
  destroyed: function () {
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/customPrice.js